module.exports = __webpack_public_path__ + "static/media/invitation.7dd5a64b.svg";